import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import { SidebarContext } from "../context/SidebarContext";
import PermissionGuard from "./PermissionGuard";

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const isWorkOrderRoute = location.pathname === "/workorder";

  return (
    <SidebarContext.Provider value={{ sidebarOpen, setSidebarOpen }}>
      <div className="bg-gray-100 min-h-screen w-full max-w-full overflow-x-hidden">
        <Sidebar />

        <div
          className={`p-2 sm:p-4 bg-gray-100 min-h-screen transition-all duration-300 min-w-0 max-w-full overflow-x-hidden siteMainContentCol ${
            isWorkOrderRoute && !sidebarOpen ? "sideMenu__close" : "sm:ml-64"
          }`}
        >
          <PermissionGuard>
            <Outlet />
          </PermissionGuard>
        </div>
      </div>
    </SidebarContext.Provider>
  );
};

export default Layout;